import { useState, useRef, lazy, Suspense, useEffect, useCallback, memo } from 'react';
import { fillParams, createUrl } from './General';
import StoryItemLoader from './StoryItemLoader';
import { getChart, getSize } from '../../utils/StoryItemUtils';
import { useAuthentication } from 'common/contexts/Authentication';

function createWidget(widget, variables, servers){
  if(!widget.data && !widget.options && !widget.source) return widget;
  if(widget.source){
    widget.data = {
      source:{
        request: {
          ...widget.source,
        },
      },
    };
  }
  const source = widget.data || widget.options;
  const newSource = fillParams(source, variables);

  const url = createUrl(newSource.source.request, servers);
  return {
    ...widget,
    data:{
      ...widget.data,
      source:{
        ...newSource.source,
        request:{
          ...newSource.source.request,
          url,
        },
      },
    },
  };
};

function StoryItem({ widget, dashboard, servers, variables, voucher, changeVoucher, changeStartDate, changeEndDate, startDate, endDate, parent }){
  const ref = useRef();
  const [ loading, setLoading ] = useState(true);
  const [ Variables, setVariables ] = useState(variables);
  const { getMerchantUuid } = useAuthentication();
  const [ Widget, setWidget ] = useState(widget);

  const Chart = lazy(() => import('@yoso/analytics-ui-components')
    .then(module => ({ default: module[ getChart(widget) ] })));

  function createStyle(item, parent = null){
    return {
      flexBasis: `calc(${item.basis ? item.basis : parent ? Math.round(100 / parent?.children.length) : '30%'} - 2rem)`,
      margin: '1rem',
      borderRadius: '20px',
      background: 'white',
      display: 'flex',
      justifyContent: 'center',
      minHeight: '20rem',
      padding: '1rem',
    };
  };

  useEffect(() => {
    if(widget && servers){
      setVariables(dashboard.variables.map(variable => fillVariables(variable)));
    }
  }, [ voucher, startDate, endDate, widget, servers ]);

  const fillVariables = useCallback((variable) => {
    const { name } = variable;
    const obj = { name };

    switch(name){
      case 'merchant_uuid':
        obj.value = getMerchantUuid();
        break;
      case 'voucher_id':
        if(voucher){
          obj.value = voucher.x;
        }
        break;
      case 'date_start':
        obj.value = startDate;
        break;
      case 'date_end':
        obj.value = endDate;
        break;
      default:
        obj.value = '';
        break;
    };
    return obj;
  }, [ getMerchantUuid, voucher, startDate, endDate ]);

  useEffect(() => {
    if(ref.current){
      setLoading(false);
    }
  }, [ widget, ref, Chart ]);

  useEffect(() => {
    setWidget(createWidget(widget, Variables, servers));
  }, [ Variables ]);

  return(
      <div className='story-grid-item' style={createStyle(widget, parent)} ref={ ref } >
        { loading && Variables ? <StoryItemLoader /> :
          <Suspense fallback={ <StoryItemLoader /> }>
            <Chart 
              containerProps={ getSize(ref) }
              options={ Widget }
              onRowClick={ changeVoucher }
              onStartChange={ changeStartDate }
              onEndChange={ changeEndDate }
              startDate={ startDate }
              endDate={ endDate }
            />
          </Suspense>
        }
      </div>
  );
};

const MemoizedStoryItem = memo(StoryItem);
export default MemoizedStoryItem;